/* src/app/components/dashboard/dashboard.component.scss */
:host > .stats-row {
  display: flex;
  flex-direction: row;
}
:host .kpi-card {
  flex-grow: 1;
}
:host .kpi-card article {
  padding-bottom: 15px;
}
:host .kpi-card h2 {
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
}
:host .kpi-card h2 > span {
  font-size: 5rem;
  font-weight: 500;
}
:host .kpi-card h5 {
  font-size: 2rem;
  font-weight: 500;
}
/*# sourceMappingURL=dashboard.component.css.map */
